import { render } from "./Vitamines-mineraux.vue?vue&type=template&id=c9eb61da&scoped=true"
import script from "./Vitamines-mineraux.vue?vue&type=script&lang=js"
export * from "./Vitamines-mineraux.vue?vue&type=script&lang=js"

import "./Vitamines-mineraux.vue?vue&type=style&index=0&id=c9eb61da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9eb61da"]])

export default __exports__